import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AnalyticsConsent, getAnalyticsConsent, setAnalyticsConsent } from "@helpers/analytics";

// Cookie consent banner (EU ePrivacy). Google tags load only after Accept;
// Decline is remembered and nothing tracking-related ever loads. The stored
// choice can be reset from the /privacy page.
export const CookieConsent = () => {
  const { t } = useTranslation("cookieconsent");
  const [choice, setChoice] = useState<AnalyticsConsent | null>(getAnalyticsConsent());

  if (choice) return null;

  const decide = (consent: AnalyticsConsent) => {
    setAnalyticsConsent(consent);
    setChoice(consent);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 p-3">
      <div className="mx-auto flex max-w-xl flex-col gap-3 rounded-xl border border-base-200 bg-base-100 p-4 shadow-lg sm:flex-row sm:items-center">
        <p className="flex-1 text-sm font-light">
          {t("message")}{" "}
          <Link to="/privacy" className="underline">
            {t("privacyLink")}
          </Link>
        </p>
        <div className="flex justify-end gap-2">
          <button className="btn-ghost btn-sm btn" onClick={() => decide("denied")} type="button">
            {t("decline")}
          </button>
          <button className="btn-primary btn-sm btn" onClick={() => decide("granted")} type="button">
            {t("accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
